import { useMemo } from "react";

import { useLocalizedDate } from "app/pages/activation/hooks/helpers/useLocalazedDate";
import { getLastMonthDuration, getLastWeekDuration } from "app/common/benchmark/dateHelpers";

import { BenchmarkGranularity } from "../../types/common";

export const useFormattedDuration = (granularity: BenchmarkGranularity, duration?: string, isShort = false) => {
    const defaultWeeklyDuration = useMemo(() => getLastWeekDuration(), []);
    const defaultMonthlyDuration = useMemo(() => getLastMonthDuration(), []);

    const formattedDuration = useLocalizedDate(granularity, duration, isShort);

    return {
        defaultDuration: granularity === BenchmarkGranularity.WEEKLY ? defaultWeeklyDuration : defaultMonthlyDuration,
        formattedDuration,
    };
};
